import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';

import {
  SupplierAddress,
  CreateSupplierAddressRequest,
  UpdateSupplierAddressRequest,
  SupplierMainAddress,
} from './SupplierAddress.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/suppliers`;

export async function listSupplierAddresss(
  supplierId: number,
  params?: PageRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${supplierId}/address`,
    params,
  )) as unknown;

  return result as { data: SupplierAddress[] };
}

export async function createSupplierAddress(
  supplierId: number,
  obj: CreateSupplierAddressRequest,
): Promise<SupplierAddress> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${supplierId}/address`,
    obj,
    null,
  )) as unknown;

  return result as SupplierAddress;
}

export async function updateSupplierAddress(
  supplierId: number,
  obj: UpdateSupplierAddressRequest,
): Promise<SupplierAddress> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${supplierId}/address`,
    obj,
    null,
  )) as unknown;

  return result as SupplierAddress;
}

export async function deleteSupplierAddress(supplierId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${supplierId}/address`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function getSupplierMainAddress(supplierId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${supplierId}/address/main`,
    {},
  )) as unknown;

  return result as SupplierMainAddress;
}
